import { render, staticRenderFns } from "./ChemImageWithLinks.vue?vue&type=template&id=44f3e8a9"
import script from "./ChemImageWithLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./ChemImageWithLinks.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports